import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button';

import $ from "jquery";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import ShowPasswordClose from "./../../../assets/icons/show-password-icon-close.png";
import ShowPasswordOpen from "./../../../assets/icons/show-password-icon-open.png";


export default function ChangePassword() {

    const [password, setPassword] = useState({
        current_password: "",
        new_password: "",
        confirm_password: ""
    });

    const navigate = useNavigate();

    // Timer
    const [timer2, setTimer2] = useState(90);
    useEffect(() => {
        if (timer2 <= 0) {
            $("#resetOtpBtn").hide();
            $("#resetOtpBtnActive").show();
        };

        const timerInterval = setInterval(() => {
            setTimer2(timer2 - 1);
        }, 1000);

        return () => clearInterval(timerInterval);
    }, [timer2]);


    const handleChange = (e) => {
        setPassword({ ...password, [e.name]: e.value });
    }

    const handleSubmit = e => {
        e.preventDefault();

        if (password.currentPassword.length < 7 || password.currentPassword.length > 32) {
            toast.error("Password must be 8 to 32 character long.");
            return;
        }

        if (password.newPassword === password.confirmPassword) {

            const reqBody = {
                current_password: password.currentPassword,
                new_password: password.newPassword,
                confirm_password: password.confirmPassword
            };

            // resetFormData();

            PostLoginPostApi("user/profile/change-password", JSON.stringify(reqBody), 4).then((responseJson) => {
                let response = JSON.stringify(responseJson);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        toast.success("Password change successfully. Please wait you are redirecting...");

                        setTimeout(() => {
                            navigate("/dashboard/logout");
                        }, 2000);

                        return;
                    }


                    toast.error(responseData["messages"].toString());
                    return;
                }

                toast.error("A problem occur. Please try again.");
                return;
            }).catch((error) => {
                toast.error("A problem occur. Please try again.");
            });

            return;
        }


        toast.error("Password and confirm password does not match.");
        return;
    }

    const showCurrentPassword = (id) => {
        $(".show-current-pass-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-current-pass-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-current-pass-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }

    const showPassword = (id) => {
        $(".show-password-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-password-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-password-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }


    const showConfirmPassword = (id) => {
        $(".show-confirm-pass-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-confirm-pass-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-confirm-pass-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }


    return (
        <>
            <h1 className="font-bold text-lg mb-3 px-2">Change Password</h1>

            {/* REQUEST CHANGE Password */}
            <form method="POST" id="password-form" onSubmit={handleSubmit} className="form-body max-w-[650px]" autoComplete='off'>
                <table className="custom-details-table w-full mt-0 mb-5 no-hover">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Current Password *
                            </td>
                            <td className="px-0 text-base">
                                <div className="relative bg-white rounded-md">
                                    <input type="password" name="currentPassword" id="currentPassword" minLength={8} maxLength={32} value={password.currentPassword} onChange={(e) => handleChange(e.target)} autoComplete='off' className="custom-text-replace block pl-2.5 rounded-t-lg px-2.5 pb-3 pt-4 w-full text-[15px] text-[#222222] bg-white dark:bg-gray-700 border-0 border-b-2 border-white appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#34A853] peer" placeholder=" " required />

                                    <label htmlFor="currentPassword" className="absolute text-base pt-1 text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-3.5 z-10 origin-[0] left-2.5 peer-focus:text-[#34A853] peer-focus:dark:text-[#34A853] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3"></label>

                                    <img alt="Show Password" className="show-current-pass-icon" src={ShowPasswordOpen} onClick={() => showCurrentPassword("currentPassword")}></img>
                                    <img alt="Show Password" style={{ display: "none", marginTop: "-36px", marginRight: "7px" }} className="show-current-pass-icon" src={ShowPasswordClose} onClick={() => showCurrentPassword("currentPassword")}></img>

                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="font-semibold text-base">
                                New Password *
                            </td>
                            <td className="px-0 text-base">
                                <div className="relative bg-white rounded-md">
                                    <input type="password" name="newPassword" id="newPassword" minLength={8} maxLength={32} value={password.newPassword} onChange={(e) => handleChange(e.target)} autoComplete='off' className="custom-text-replace block pl-2.5 rounded-t-lg px-2.5 pb-3 pt-4 w-full text-[15px] text-[#222222] bg-white dark:bg-gray-700 border-0 border-b-2 border-white appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#34A853] peer" placeholder=" " required />

                                    <label htmlFor="newPassword" className="absolute text-base pt-1 text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-3.5 z-10 origin-[0] left-2.5 peer-focus:text-[#34A853] peer-focus:dark:text-[#34A853] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3"></label>

                                    <img alt="Show Password" className="show-password-icon" src={ShowPasswordOpen} onClick={() => showPassword("newPassword")}></img>
                                    <img alt="Show Password" style={{ display: "none", marginTop: "-36px", marginRight: "7px" }} className="show-password-icon" src={ShowPasswordClose} onClick={() => showPassword("newPassword")}></img>

                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="font-semibold text-base">
                                Confirm New Password *
                            </td>
                            <td className="px-0 text-base">
                                <div className="relative bg-white rounded-md">
                                    <input type="password" name="confirmPassword" id="confirmPassword" minLength={8} maxLength={32} value={password.confirmPin} onChange={(e) => handleChange(e.target)} autoComplete='off' className="custom-text-replace block pl-2.5 rounded-t-lg px-2.5 pb-3 pt-4 w-full text-[15px] text-[#222222] bg-white dark:bg-gray-700 border-0 border-b-2 border-white appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#34A853] peer" placeholder=" " required />

                                    <label htmlFor="confirmPassword" className="absolute text-base pt-1 text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-3.5 z-10 origin-[0] left-2.5 peer-focus:text-[#34A853] peer-focus:dark:text-[#34A853] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3"></label>

                                    <img alt="Show Password" className="show-confirm-pass-icon" src={ShowPasswordOpen} onClick={() => showConfirmPassword("confirmPassword")}></img>
                                    <img alt="Show Password" style={{ display: "none", marginTop: "-36px", marginRight: "7px" }} className="show-confirm-pass-icon" src={ShowPasswordClose} onClick={() => showConfirmPassword("confirmPassword")}></img>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
                <Button name="Submit" className="mt-3" />
            </form>



            <style jsx="true">{`
                table.custom-details-table tr td:first-child {
                    width: 250px !important;
                }
            `}</style>

        </>
    )
}
